import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import { TextAreaTypeV2 } from './types';
import InputLabel from '../Inputs/InputLabel';

export const TextAreaV2 = React.forwardRef<HTMLTextAreaElement, TextAreaTypeV2>(
  (
    {
      id,
      label,
      placeholder = '',
      disabled,
      required = false,
      readOnly,
      shape = 'squre',
      textColorClassName = 'text-textPrimary',
      bgColorClassName = 'bg-white',
      value,
      onChange,
      inputHtmlType = 'text',
      prefix,
      suffix,
      inputExtraClassNames,
      isError,
      fieldState,
      span,
      rows = 4,
    }: TextAreaTypeV2,
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange && onChange(e.target.value);
    };

    const { t } = useTranslation();

    return (
      <div className="w-full">
        {label && (
          <InputLabel
            name={id ?? ''}
            text={t(`inputs.labels.${label}`, label.toString() || '') as string}
            required={required}
            hint={span}
          />
        )}
        <div
          className={`relative ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } shadow-sm`}
        >
          {prefix && (
            <div
              className={`absolute inset-y-1 ltr:left-0 rtl:right-0  pl-3 flex items-center pointer-events-none`}
            >
              <span className="text-gray-500 sm:text-sm">{prefix}</span>
            </div>
          )}
          <textarea
            ref={ref}
            rows={rows}
            id={id}
            required={required}
            value={value}
            onChange={handleChange}
            className={`w-full border ${
              !isError
                ? 'focus:border-primary focus:ring-0 focus:ring-primary'
                : 'focus:border-red-500 focus:ring-0 focus:ring-red-500'
            } ${
              shape === 'circle' ? 'rounded-full' : 'rounded-md'
            } focus:border-primary ${
              prefix && 'pl-7'
            } pe-12 sm:text-sm border-gray-300 ${bgColorClassName} ${textColorClassName} ${inputExtraClassNames}`}
            placeholder={
              t(
                `inputs.placeholders.${placeholder}`,
                placeholder || ''
              ) as string
            }
          />
          <div
            className={`absolute h-auto inset-y-1 ltr:right-0 rtl:left-0  flex items-center`}
          >
            {suffix}
          </div>
          {isError && (
            <div className="absolute top-[105%] right-0 text-[12px] text-red-500">
              <ReturnTranslatedText
                origintext={fieldState?.error?.message}
                text={`general.${fieldState?.error?.message}`}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
);
